/* eslint-disable import/no-duplicates */
import React, { useState } from 'react';
import { Chart } from 'react-google-charts';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useCurrentEffect } from '../../../../../../../../lib/use-current-effect';

import {
  getMeasurementsByDay,
  getMeasurementsByDateRange,
} from '../../../../../../../../services/metrics';
import { usePatient } from '../../../../../../../../hooks/patient';

import Default, { ShowScreenType } from '../_Default';
import { ChartsProps } from '../../MetricView';

import { ChartArea, Legend } from './styles';
import { MetricTypeEnum } from '../../../../../../../../enums/MetricTypeEnum';

const BloodPressureChart: React.FC<ChartsProps> = ({ dateRange }) => {
  const { patient } = usePatient();

  const [showScreen, setShowScreen] = useState<ShowScreenType>('loading');
  const [graphData, setGraphData] = useState<(string | number)[][]>([
    ['00:00', 0, 0],
  ]);

  useCurrentEffect(
    (isCurrent) => {
      (() => {
        if (patient?.id) {
          if (isCurrent()) {
            setShowScreen('loading');
          }

          const { startDate, endDate } = dateRange;

          if (startDate === endDate) {
            getMeasurementsByDay({
              patientId: patient.id,
              metricType: MetricTypeEnum.BLOOD_PREASSURE,
              dateFilter: startDate,
            })
              .then((response) => {
                if (isCurrent()) {
                  if (response.length > 0) {
                    const result = response.map(
                      ({ hightPressure, lowPressure, mensuramentDate }) => [
                        format(new Date(mensuramentDate), 'HH:mm', {
                          locale: ptBR,
                        }),
                        hightPressure,
                        lowPressure,
                      ],
                    );

                    setShowScreen('chart');
                    setGraphData(result);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          } else {
            getMeasurementsByDateRange({
              patientId: patient.id,
              metrics: MetricTypeEnum.BLOOD_PREASSURE,
              startDate,
              endDate,
            })
              .then((response) => {
                if (isCurrent()) {
                  if (response.length > 0) {
                    const result = response.map(
                      ({ hightPressure, lowPressure, mensuramentDate }) => [
                        format(new Date(mensuramentDate), "dd'/'MM", {
                          locale: ptBR,
                        }),
                        hightPressure,
                        lowPressure,
                      ],
                    );

                    setShowScreen('chart');
                    setGraphData(result);
                  } else {
                    setShowScreen('noData');
                  }
                }
              })
              .catch(() => {
                if (isCurrent()) {
                  setShowScreen('noData');
                }
              });
          }
        }
      })();
    },
    [dateRange, patient],
  );

  return (
    <Default showScreen={showScreen}>
      <ChartArea>
        <Chart
          chartType="LineChart"
          width="100%"
          height="300px"
          style={{
            marginBottom: '40px',
          }}
          options={{
            colors: ['#2D9CDB', '#30E3E5'],
            legend: {
              position: 'none',
            },
            chartArea: { left: 40, right: 40 },
          }}
          data={[
            ['h', 'Pressão Sistólica', 'Pressão Diastólica'],
            ...graphData,
          ]}
          rootProps={{ 'data-testid': '1' }}
        />

        <Legend markerColor="#2D9CDB">
          <span>Pressão Sistólica</span>
        </Legend>

        <Legend markerColor="#30E3E5">
          <span>Pressão Diastólica</span>
        </Legend>
      </ChartArea>
    </Default>
  );
};

export default BloodPressureChart;
